import React, { useRef } from 'react'
import { Button } from 'reactstrap'
import { IconButton } from '@mui/material'
import { AttachFile, Close } from '@material-ui/icons'
import { v4 as uuidv4 } from 'uuid'
import moment from 'moment'

const extractFileExtension = (path = '') => {
  const match = String(path).match(/\.([0-9a-z]+)(?=[?#])|(\.)(?:[\w]+)$/gmi)
  return match?.[0]?.substring(1) || ''
}

const formatAcceptedFiles = (acceptedFiles = []) => (
  acceptedFiles.map((file) => {
    const path = file.path || file.name || ''
    return {
      data: file,
      props: {
        id: uuidv4(),
        preview: URL.createObjectURL(file),
        modified: moment().format('DD/MM/YYYY HH:mm'),
        name: path.replace(/\.[^/.]+$/, ''),
        extension: extractFileExtension(path),
        documentType: null,
        description: null,
      },
    }
  })
)

function CompactAddFiles({
  files = [],
  onFilesChange = () => {},
  multiple = true,
  disabled = false,
  readOnly = false,
}) {
  const inputRef = useRef(null)
  const isDisabled = disabled || readOnly
  const currentFiles = Array.isArray(files) ? files : []

  const handlePickClick = () => {
    if (isDisabled) return
    inputRef.current?.click()
  }

  const handleInputChange = (event) => {
    const selected = Array.from(event.target.files || [])
    event.target.value = ''
    if (selected.length <= 0) return

    const formatted = formatAcceptedFiles(selected)
    const nextFiles = multiple ? currentFiles.concat(formatted) : formatted
    onFilesChange(nextFiles)
  }

  const handleRemove = (fileId) => {
    if (isDisabled) return
    const nextFiles = currentFiles.filter((file) => file?.props?.id !== fileId)
    onFilesChange(nextFiles)
  }

  return (
    <div className="d-flex flex-column" style={{ gap: 4, minWidth: 140, maxWidth: 220 }}>
      <div className="d-flex align-items-center" style={{ gap: 4 }}>
        <Button
          size="sm"
          color="link"
          className="p-0"
          disabled={isDisabled}
          onClick={handlePickClick}
          title="Anexar arquivo"
        >
          <AttachFile style={{ fontSize: 18, verticalAlign: 'middle' }} />
          <span style={{ fontSize: 12, marginLeft: 2 }}>Anexar</span>
        </Button>
        <input
          ref={inputRef}
          type="file"
          hidden
          multiple={multiple}
          disabled={isDisabled}
          onChange={handleInputChange}
        />
      </div>

      {currentFiles.map((file) => {
        const fileId = file?.props?.id
        const label = file?.data?.path || file?.data?.name || file?.props?.name || 'arquivo'
        return (
          <div
            key={fileId}
            className="d-flex align-items-center"
            style={{ gap: 2, minWidth: 0 }}
            title={label}
          >
            <span
              style={{
                fontSize: 11,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                flex: 1,
                minWidth: 0,
              }}
            >
              {label}
            </span>
            {!isDisabled && (
              <IconButton
                size="small"
                title="Remover"
                onClick={() => handleRemove(fileId)}
                style={{ padding: 2 }}
              >
                <Close style={{ fontSize: 14 }} />
              </IconButton>
            )}
          </div>
        )
      })}
    </div>
  )
}

export default CompactAddFiles
